import { assert_number_gte_0, assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO__file_data extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.FILE_DATA;

  /*
   * INSTANCE FIELDS
   */
  blob!: Uint8Array;
  filename!: string;
  mimetype!: string;
  size!: number;

  /*
   * METHODS
   */
  constructor() {
    super();
    this.blob = new Uint8Array(0);
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.filename);
    assert_string_not_empty(this.mimetype);
    assert_number_gte_0(this.size);
  }
}
